import React from "react";
import { useRoutes } from "react-router-dom";
import MobileForm from "./Components/MobileForm";
import ValidateOtp from "./Components/ValidateOtp";
import CheckCreditScore from '../../Common/Components/CheckCreditScore';
import CreditScoreReport from '../../Common/Components/CreditScoreReport';

let routes = [
    {
        "path": "/",
        "element": <MobileForm />
    },
    {
        "path": "/verify-otp",
        "element": <ValidateOtp />
    },
    {
        "path": "/personal-details",
        "element": <CheckCreditScore />
    },
    {
        "path": "/credit-score",
        "element": <CreditScoreReport />
    },
]
let Routes = () => useRoutes(routes);

export default Routes;